import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    ConfirmationWindowComponent,
    ConfirmationWindowTypes,
} from '@components/confirmation-window/confirmation-window.component';
import { AutosavePage } from '@service/auto-save-controller.service';
import { ElementIntegrationService } from '@service/element-integration.service';
import {
    ElementIntegration,
    ElementIntegrationType,
    INTEGRATION_TYPE,
} from 'icreate/common/models/element-integration';
import { Vessel } from 'icreate/common/models/vessel';
import { lastValueFrom, take } from 'rxjs';

@Component({
    selector: 'app-integration-dialog',
    templateUrl: './integration-dialog.component.html',
    styleUrls: ['./integration-dialog.component.css'],
    standalone: false,
})
export class IntegrationDialogComponent implements OnInit {
    readonly STATUS_COLOR = INTEGRATION_TYPE.STATUS_COLOR;
    readonly VISUAL_STATE = INTEGRATION_TYPE.VISUAL_STATE;

    isLoading: boolean = false;
    isEditing: boolean = false;
    isOpenHelper: boolean = false;

    @ViewChild('deleteDialog') deleteDialog: ConfirmationWindowComponent;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            vessel: Vessel;
            elementId: string;
            mimicId: string;
            integration: ElementIntegration;
        },
        private dialogRef: MatDialogRef<IntegrationDialogComponent>,
        private elementIntegrationService: ElementIntegrationService
    ) {}

    ngOnInit() {
        if (!this.data.integration) {
            this.data.integration = {
                id: null,
                conditionId: null,
                mimicId: this.data.mimicId,
                elementId: this.data.elementId,
                type: '',
            };
        } else {
            this.isEditing = true;
        }
    }

    isSetupButtonDisabled() {
        return !this.data.integration.type;
    }

    setIntegrationType(type: ElementIntegrationType) {
        this.data.integration.type = type;
    }

    openHelper() {
        this.isOpenHelper = !this.isOpenHelper;
    }

    async setUpIntegrate() {
        let newIntegrate;
        try {
            this.isLoading = true;
            if (this.data.integration.id) {
                newIntegrate = await this.update();
            } else {
                newIntegrate = await this.create();
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.isLoading = false;
            this.close(newIntegrate);
        }
    }

    async deleteIntegration() {
        try {
            this.deleteDialog.setVisible(true, true, AutosavePage.MIMIC);
            const option = await lastValueFrom(this.deleteDialog.onOptionSelected.pipe(take(1)));
            if (option === ConfirmationWindowTypes.SAVE) {
                await this.elementIntegrationService.deleteByElementId(this.data.elementId);
                this.close(undefined);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async create() {
        return await this.elementIntegrationService.create(this.data.integration);
    }

    async update() {
        return await this.elementIntegrationService.update(this.data.integration);
    }

    close(result) {
        this.dialogRef.close(result);
    }
}
